import { IVendorRequirementModel } from '../../../../../../../service/requirement/vendor/IVendorRequirementModel';
import { IVendorRequirementService } from '../../../../../../../service/requirement/vendor/IVendorRequirementService';
import { IRowContextMenuUI } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/IRowContextMenuUI';
import { RowContextMenuDomain } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuDomain';
import { IDataTableDomain } from '../../../../../../design/dataTable/store/IDataTableDomain';
import { IMainLayoutDomainStore } from '../../../../../../layout/main/store/domain/IMainLayoutDomainStore';
import { VendorRequirementContextMenuUI } from './VendorRequirementContextMenuUI';

export class VendorRequirementContextMenuDomain extends RowContextMenuDomain<IVendorRequirementModel> {
  constructor({
    entityService,
    dataTableDomain,
    layoutDomain,
    ui,
  }: {
    entityService: IVendorRequirementService;
    dataTableDomain: IDataTableDomain<IVendorRequirementModel, any>;
    layoutDomain: IMainLayoutDomainStore;
    ui?: IRowContextMenuUI<IVendorRequirementModel> | null;
  }) {
    super(entityService, dataTableDomain, layoutDomain, ui);
    this.ui = ui || new VendorRequirementContextMenuUI(this);
  }
}
